import React from 'react';

export interface WidgetErrorFallbackProps {
    /**
     * Custom error message to display
     * @default "Something went wrong loading this widget."
     */
    message?: string;
    /**
     * Callback function when refresh button is clicked
     * @default () => window.location.reload()
     */
    onRefresh?: () => void;
    /**
     * Custom button text
     * @default "Refresh"
     */
    refreshButtonText?: string;
}

/**
 * Reusable error fallback component for widgets with embedded styles
 * Displays an error message and a refresh button
 */
export const WidgetErrorFallback: React.FC<WidgetErrorFallbackProps> = ({
    message = 'Something went wrong loading this widget.',
    onRefresh = () => window.location.reload(),
    refreshButtonText = 'Refresh',
}) => {
    return (
        <div
            role="alert"
            style={{
                fontFamily: 'inherit',
                fontSize: '14px',
                color: '#000',
                textAlign: 'center',
                padding: '24px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
            }}
        >
            <div>{message}</div>
            <button
                onClick={onRefresh}
                style={{
                    backgroundColor: '#1976d2',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '4px',
                    padding: '8px 16px',
                    fontSize: '14px',
                    cursor: 'pointer',
                    fontFamily: 'inherit',
                    transition: 'background-color 0.2s',
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#1565c0';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#1976d2';
                }}
            >
                {refreshButtonText}
            </button>
        </div>
    );
};
